export default "__VITE_ASSET__Dua0pYNS__"